import styled from "styled-components";

export const QuantityInputStyled = styled.div`
    display: flex;
    align-items: center;

    padding: 0 20px;
`;

export const Container = styled.div`
    width: 55px;

    > div {
        margin-bottom: 0;
    }

    input {
        padding: 0;

        text-align: center;
    }
`;

export const Left = styled.div`
    margin: 16px;
`;

export const Right = styled.div`
    margin: 16px;
`;

export const Button = styled.button`
    padding: 4px;

    user-select: none;

    img {
        width: 21px;
    }
`;
